import { render, staticRenderFns } from "./select-result-table.vue?vue&type=template&id=8c206280&"
import script from "./select-result-table.vue?vue&type=script&lang=js&"
export * from "./select-result-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports